import { render, staticRenderFns } from "./OrgsList.vue?vue&type=template&id=220ed0ac&"
import script from "./OrgsList.vue?vue&type=script&lang=js&"
export * from "./OrgsList.vue?vue&type=script&lang=js&"
import style0 from "./OrgsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports